<template>
		<el-drawer
			class="breathe-create-theme"
		    title="外呼主题配置" 
		    :visible.sync="dialog_visible"
		    :wrapperClosable="false"
			size="800px"
		    direction="rtl">
			<section  v-show="is_show_step"  style="padding: 0 20px;margin-bottom: 20px;height: 50px;">
				<el-steps :active="active" simple>
				    <el-step title="创建外呼主题"></el-step>
				    <el-step title="生成外呼任务"></el-step>
				    <el-step title="分配外呼任务"></el-step>
				</el-steps>
			</section>
			<!-- 第一步 -->
			<section v-if="active == 1">
				<h1>基础信息</h1>
				<el-form :model="form" :rules="rules" ref="form" label-width="110px" style="margin-top: 20px;">
					<el-row>
						<el-col :span="12">
							<el-form-item label="子品牌" prop="childBrandIdentify">
							  <el-select v-model="form.childBrandIdentify" placeholder="请选择子品牌" filterable  clearable style="width: 100%;">
							      <el-option
									v-for="item in childBrandOptions"
							        :key="item.id"
							        :label="item.name"
							        :value="item.id">
							      </el-option>
							    </el-select>
							 </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="主题分类" prop="campaignName">
							   <el-input v-model="form.campaignName" disabled></el-input>
							 </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="主题名称" prop="subjectName">
							   <el-input v-model="form.subjectName" placeholder="请输入主题名称"></el-input>
							 </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="主题状态" prop="subjectStatus">
							     <el-select v-model="form.subjectStatus" placeholder="请选择主题状态" clearable style="width: 100%;">
							       <!-- <el-option value="0" label="正常">正常</el-option> -->
								   <el-option value="1" label="待启用">待启用</el-option>
								   <el-option value="2" label="已启用">已启用</el-option>
							     </el-select>
							 </el-form-item>
						</el-col>
						
					</el-row>
					  <el-form-item label="主题说明" prop="subjectRemarks">
					    <el-input type="textarea" v-model="form.subjectRemarks" placeholder="请输入主题说明"></el-input>
					  </el-form-item>
					  <h1>配置信息</h1>
					  <el-row  style="margin-top: 20px;">
					  	<el-col :span="12">
					  		<el-form-item label="外呼问卷" prop="surveyId" class="el-row-flex">
								<el-select
									 @focus="getQuestionOptions()"
									  remote 
									 :remote-method="getQuestionOptions" 
									 v-model="form.surveyId" placeholder="请选择外呼问卷" filterable  clearable style="width: 100%;">
										<el-option
										  v-for="item in questionEventOptions"
										  :key="item.paperId"
										  :label="item.paperName"
										  :value="item.paperId">
										</el-option>
								  </el-select>
								<el-button type="text" size="mini" @click="onPreviewPaper" style="margin-left: 10px;">预览</el-button>
					  		 </el-form-item>
					  	</el-col>
					  	<el-col :span="12">
					  		<el-form-item label="外呼数据" prop="originalBatchNum" class="el-row-flex">
							  <el-select
							   @focus="getDataBaseOptions()"
							   remote
							   filterable
							   :remote-method="getDataBaseOptions" 
							   v-model="form.originalBatchNum" placeholder="请选择外呼数据"  clearable  style="width: 100%;">
							      <el-option
									  v-for="item in databaseOptions"
										:key="item.id"
										:label="item.name"
										:value="item.id">
							      </el-option>
							    </el-select>
					  		 </el-form-item>
					  	</el-col>
					  </el-row>
					  <el-row>
					  	<el-col :span="12">
					  		<el-form-item label="优先级" prop="subjectLevel">
								<el-select v-model="form.subjectLevel" placeholder="请选择优先级" clearable style="width: 100%;">
								  <el-option value="1" label="紧急">紧急</el-option>
								  <el-option value="2" label="较高">较高</el-option>
								  <el-option value="3" label="普通">普通</el-option>
								  <el-option value="4" label="滞后">滞后</el-option>
								</el-select>
					  		 </el-form-item>
					  	</el-col>
						<el-col :span="12">
							<el-form-item  prop="autoDistint">
								<span slot="label">
									<el-popover
									   width="300"
									   trigger="hover"
									   content="开启后，对外呼数据进行一次去重">
									   <i slot="reference" class="el-icon-warning" style="margin-right: 5px;"></i>
									 </el-popover>电话去重</span>
								  <el-switch
								    v-model="form.autoDistint"
									active-value="1"
									inactive-value="2"
								    active-text="是"
								    inactive-text="否">
								  </el-switch>
							 </el-form-item>
						</el-col>
					  </el-row>
					  <el-row>
					  	<el-col :span="12">
					  		<el-form-item  prop="obTimes">
								<span slot="label">
									<el-popover
									   width="300"
									   trigger="hover"
									   content="限呼次数计算方式:拨通电话后算作一次呼出(即便对方没有接听),该指标用于避免客户受到过度骚扰.">
									   <i slot="reference" class="el-icon-warning" style="margin-right: 5px;"></i>
									 </el-popover>限呼次数</span>
								<el-input-number v-model="form.obTimes" :min="0" placeholder="请输入限呼次数" style="width: 100%;"></el-input-number>
								<p style="color: #e6a23c;">0为不限</p>
					  		 </el-form-item>
					  	</el-col>
					  	<el-col :span="12">
							<el-form-item prop="repeatDays ">
								<span slot="label">
									<el-popover
									   width="290"
									   trigger="hover"
									   content="1）默认关闭，输入数字后开启本功能 2）在本主题下，若某号码在N天内被生成过，则该号码不再生成任务。">
									   <i slot="reference" class="el-icon-warning" style="margin-right: 5px;"></i>
									 </el-popover>避免重访</span>
								<el-input-number v-model="form.repeatDays" :min="0" placeholder="不限" style="width: 85%;"></el-input-number> 天内
								<p style="color: #e6a23c;">0为不限</p>
							</el-form-item>
						</el-col>
					  </el-row>
					  <el-row>
						  <el-col :span="12">
							 <el-form-item label="自动分配" prop="autoAsign" class="el-row-flex" >
								<remoteTable type="自动分配" :modelVal="obAutoAssignUserList" :childBrand="form.childBrandIdentify" @remoteTableData="remoteTableData">
									<el-input style="width: 234px;" v-model="form.autoAsign" placeholder="请选择分配人员" disabled ></el-input>
									<el-button type="text" style="margin-left: 10px;">选择</el-button>
								</remoteTable>
							  </el-form-item>
						  </el-col>
						 <el-col :span="12" v-if="form.autoAssignUserAccounts.length > 0">
						 	<el-form-item label="分配方式" prop="autoAssignType">
						 		<el-select v-model="form.autoAssignType" placeholder="请选择分配方式" clearable style="width: 100%;">
								  <el-option value="auto" label="自动分配（任务少 按未完成量相等 进行分配，任务多 则平均分配）"></el-option>
								  <el-option value="avg" label="平均分配（每次分配，坐席被分配任务量均等）"></el-option>
						 		  <el-option value="equ" label="未完成量相等（分配后坐席未完成量均等）"></el-option>
						 		  <el-option value="equz" label="未外呼量相等（分配后坐席未外呼量均等）"></el-option>
						 		 </el-select>
						 	 </el-form-item>
						 </el-col>
					  </el-row>
					  <el-row v-if="form.autoAssignUserAccounts.length > 0">
						<el-col :span="14">
							<el-form-item prop="autoAssignTime" label="分配时间" class="el-row-flex">
								 <el-time-picker
									style="width: 135px;"
								    v-model="form.autoAssignStartTime"
								   :picker-options="{selectableRange:`00:00:00 - ${form.autoAssignEndTime ? form.autoAssignEndTime : '23:59:00'}`}"
								   value-format="HH:mm:ss" 
								   placeholder="开始时间">
								 </el-time-picker>
								 <span style="margin: 0 5px;">至</span>
								 <el-time-picker
								   style="width: 135px;"
								   value-format="HH:mm:ss" 
								   v-model="form.autoAssignEndTime"
								  :picker-options="{
								       selectableRange:`${form.autoAssignStartTime ? form.autoAssignStartTime : '00:00:00'} - 23:59:00`
								    }"
								   placeholder="结束时间">
								 </el-time-picker> 
							</el-form-item>
						</el-col>
						<el-col :span="10">
							  <el-form-item  prop="autoAssignOnline"  label="只分配给在线坐席">
								  <el-switch
								    v-model="form.autoAssignOnline" active-value="1" inactive-value="0" active-text="是" inactive-text="否">
								  </el-switch>
							  </el-form-item>
						</el-col>
					  </el-row>
					<el-form-item>
						<span slot="label">
							<el-popover
							   width="420"
							   trigger="hover"
							   content="开始时间：完成任务分配后，系统自动按时发送任务给坐席;结束时间：到期后，即便任务未完成，系统自动关闭执行任务">
							   <i slot="reference" class="el-icon-warning" style="margin-right: 5px;"></i>
							 </el-popover>执行时间</span>
							<div class="el-row-flex">
								<el-date-picker type="datetime" placeholder="开始时间" v-model="form.startTime" style="width: 135px"
								 value-format="yyyy-MM-dd HH:mm:ss" :picker-options="setStartDate"></el-date-picker>
								 <span style="margin: 0 5px;">至</span>
								 <el-date-picker type="datetime" placeholder="选择时间" v-model="form.endTime" style="width: 135px"
								  value-format="yyyy-MM-dd HH:mm:ss" :picker-options="setEndDate"></el-date-picker>
							</div>
					</el-form-item>
					<div class="more-setting">
						<h1 @click="is_show_more_setting = !is_show_more_setting">更多设置 <i :class=" is_show_more_setting ? 'el-icon-caret-top':'el-icon-caret-bottom'"></i></h1>
						  <transition name="el-zoom-in-top">
						        <div v-show="is_show_more_setting" style="margin-top: 15px;">
									<el-form-item label="虚拟号码地址" prop="virtualPhoneNumberUrl">
										<el-input v-model="form.virtualPhoneNumberUrl" clearable placeholder="请输入虚拟号码地址"></el-input>
									</el-form-item>
									<el-form-item label="定制化处理类" prop="surveyAfterClass">
										<el-input v-model="form.surveyAfterClass" clearable placeholder="请输入定制化处理类"></el-input>
									</el-form-item>
								</div>
						 </transition>
					</div>
				</el-form>
			</section>
			<!-- 第二步 -->
			<section v-if="active == 2" class="step-two">
				<p>当前主题有【{{notCreatedCount}}】条数据尚未生成任务</p>
				<!-- <p>
					<el-checkbox v-model="isHadTaskFinishTime">任务执行时间</el-checkbox>
					<el-date-picker
						 :disabled="!isHadTaskFinishTime"
						  style="margin-left: 10px;"
					      v-model="taskFinishTime"
						  value-format="yyyy-MM-dd HH:mm:ss"
					      type="datetimerange"
					      range-separator="至"
					      start-placeholder="开始日期"
					      end-placeholder="结束日期">
					</el-date-picker>
				</p> -->
				<!-- <p class="desc">
					<span><i class="el-icon-info" style="margin-right: 4px;"></i>开始时间：完成任务分配后，系统自动按时发送任务给坐席</span>
					<span style="padding-left: 16px;">结束时间：到期后，即便任务未完成，系统自动关闭执行任务</span>
				</p> -->
				<div class="step-two-result" v-show="isSubmitTask">
					<el-tag type="success">成功: {{task_result.TASK_SUCCESS}}</el-tag>
					<el-tag type="info" style="margin: 0 10px;">过滤: {{task_result.TASK_REPEAT}}</el-tag>
					<el-popover
					    title="失败原因"
					    width="200"
					    trigger="click">
						<el-table :data="task_result.TASK_FAIL_list" style="height: 400px; overflow: auto;">
						    <el-table-column type="index" label="序号"></el-table-column>
						    <el-table-column label="原因">
								<template slot-scope="scope">{{scope.row}}</template>
							</el-table-column>
						 </el-table>
					   <el-tag type="danger" slot="reference">失败: {{task_result.TASK_FAIL}}</el-tag>
					  </el-popover>
					<p class="desc" style="margin-top: 20px;">
						<span><i class="el-icon-info" style="margin-right: 4px;"></i>过滤：未生成任务的数据发现有电话号码重复，只保留一个</span>
						<span style="padding-left: 16px;">失败：系统内部出错，可点击查看</span>
					</p>
				</div>
			</section>
			<!-- 第三步 -->
			<section v-if="active == 3">
				<p>打开<el-button type="text" @click="goTask">外呼任务</el-button>，选择分配方式</p>
			</section>
			<div class="footer" v-show="active != 3">
				<el-button @click="dialog_visible = false" size="mini">取 消</el-button>
				<el-button type="primary" size="mini" @click="onSave" :loading="loading" v-if="!isSubmitTask">
					{{ loading ? '提交中 ...' : active == 1 ? '保 存' : '生成任务' }}
				</el-button>
				<el-button v-else type="primary" size="mini" @click="active = 3">去分配外呼任务</el-button>
			</div>
			<!-- 主题预览 -->
			 <el-drawer
			     :title="paperInfos.formInfo.paperName"
				 size="700px"
			     :append-to-body="true"
			     :visible.sync="inner_dialog_visible">
					<section style="padding: 0 20px;">
							<FormPreview :formData="paperInfos"  
							v-if="paperInfos.formDesign.length > 0" />
					</section>
			   </el-drawer>
		</el-drawer>
</template>

<script>
	import remoteTable from './remoteTable.vue';
	import FormPreview from "@/components/SurveyDesign/components/FormPreview";
	import {mapGetters} from 'vuex';
	export default {
		components: {
			remoteTable,
			FormPreview
		},
		computed: {
			...mapGetters([
				'userInfo',  
				'subBrandList'
			]),
			setStartDate(){
				let that = this;
				return {
					disabledDate(time){
						let time_s = new Date(that.form.endTime).getTime();
						return time.getTime() > time_s || time.getTime() > Date().now;
					}
				}
			},
			setEndDate(){
				let that = this;
				return {
					disabledDate(time){
						let time_s = new Date(that.form.startTime).getTime();
						return time.getTime() < time_s || time.getTime() > Date().now;
					}
				}
			}
		},
		data() {
			return {
				is_show_more_setting:false,
				active:1,
				is_show_step:false,
				visible:false,
				title: '新增主题',
				dialog_visible:false,
				inner_dialog_visible:false,
				loading:false,
				form:{
					brandIdentify:'',
					childBrandIdentify:'',
					subjectName:'',
					subjectId:'',
					campaignName:'',
					subjectRemarks:'',
					originalBatchNum:'',
					originalBatchRemarks:'',
					surveyId:'',
					surveyName:'',
					subjectStatus:'2',
					subjectLevel:'',
					obTimes:'',
					autoDistint:'1',
					autoAsign:'',
					autoAssignUserAccounts:[],
					autoAssignUserIds:[],
					autoAssignUserNicknames:[],
					autoAssignType:'auto',
					repeatDays :'',//避免重访
					startTime:'',
					endTime:'',
					autoAssignOnline:'',//是否只分配给在线坐席
					autoAssignStartTime:'',//分配开始时间
					autoAssignEndTime:'',//分配结束时间
					virtualPhoneNumberUrl:'',
					surveyAfterClass:''
				},
				rules:{
					subjectName:[{required:true,message:'请填写主题名称',trigger:'blur'}],
					originalBatchNum:[{required:true,message:'请选择外呼数据',trigger:'change'}],
					surveyId:[{required:true,message:'请选择外呼问卷',trigger:'change'}],
				},
				childBrandOptions:[],
				questionEventOptions:[],//外呼问卷数据
				databaseOptions:[],
				taskFinishTime:'',//任务执行时间
				isHadTaskFinishTime:false,
				obAutoAssignUserList:[],//自动匹配回填数据
				isSubmitTask:false,//是否已生成任务
				notCreatedCount:0,
				task_result:{
					TASK_FAIL:0,
					TASK_REPEAT:0,
					TASK_REPEATOB:0,
					TASK_SUCCESS:0,
					TASK_FAIL_list:[],
				},
				paperInfos:{
					formInfo: {},
					formDesign: [],
					formSelect: {},
				},
			}
		},
		methods: {
			onPreviewPaper(){
				if(!this.form.surveyId) return this.$notify.error('请先选择问卷');
				this.$api.apiGetSurveyPaperInfo({
					paperId: this.form.surveyId
				}).then(res => {
					if(res.errcode != 0) return;
					this.paperInfos = {
						formInfo: res.data.surveyPaper,
						formDesign:res.data.surveyQuestionList,
						formSelect: {},
					}
					this.inner_dialog_visible = true;
				})
			},
			goTask(){
				this.dialog_visible = false;
				this.$router.push({
					path:`/breathe/task`,
					query:{
						subjectId:this.form.subjectId
					}
				})
			},
			onSave() {
				switch(this.active){
					case 1:
						this.submitTheme();
						break;
					case 2:
						this.submitTask();
						break;
				}
			},
			submitTask(){
				if(this.isHadTaskFinishTime && !this.taskFinishTime){
					this.$notify.error('请填写任务执行时间');
					return;
				}
				if(this.notCreatedCount == 0){
					this.$notify.error('没有可生成的任务');
					return;
				}
				this.$api.createTaskBreathTask({
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					subjectId:this.form.subjectId,
				}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('成功生成任务');
					this.isSubmitTask = true;
					this.task_result = res.data;
					this.task_result.TASK_FAIL_list = Object.values(res.data.TASK_FAIL_list).length > 0 ? Object.values(res.data.TASK_FAIL_list) : [];
					
				})
				
			},
			submitTheme(){
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						this.form.brandIdentify = this.$store.getters.userInfo.brandIdentify;
						let params = JSON.parse(JSON.stringify(this.form));
						params.repeatDays = params.repeatDays ? params.repeatDays : '';
						params.autoAssignUserAccounts = params.autoAssignUserAccounts.join(',');
						params.autoAssignUserIds = params.autoAssignUserIds.join(',');
						params.autoAssignUserNicknames = params.autoAssignUserNicknames.join(',');
						params.autoAsign = this.form.autoAssignUserAccounts.length > 0 ? '0' : '1';
						if(!params.surveyAfterClass){
							delete params.surveyAfterClass;
						}
						if(this.form.autoAssignUserAccounts.length == 0){
							params.autoAssignEndTime = '';
							params.autoAssignOnline = '';
							params.autoAssignStartTime = '';
						}
						// let survery = this.questionEventOptions.filter(el => el.paperId == this.form.surveyId);
						// let remarks = this.databaseOptions.filter(el => el.id == this.form.originalBatchNum);
						// params.surveyName = survery.length > 0 ? survery[0].paperName : '';
						// params.originalBatchRemarks = remarks.length > 0 ? remarks[0].name : '';
						if(this.form.subjectId){
							this.$api.editBreathThemeList(params).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								 this.$notify.success({
								   message: '操作成功',
								   position: 'top-right'
								 });
								 this.dialog_visible = false;
								 this.$emit('getThemesLists')
							}).catch(err => {
								this.loading = false;
							})
						}else {
							this.$api.addBreathThemeList(params).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								 this.$notify.success({
								   message: '操作成功',
								   position: 'top-right'
								 });
								 this.$emit('getThemesLists')
								 this.active = 2;
								 this.form.subjectId = res.data;
								 this.getTaskNum();
							}).catch(err => {
								this.loading = false;
							})
						}
						
					}
				})
			},
			remoteTableData(data){
				this.form.autoAssignUserAccounts = [];
				this.form.autoAssignUserIds = [];
				this.form.autoAssignUserNicknames = [];
				if(data.type == '自动分配'){
					for(let item of data.lists){
						this.form.autoAssignUserAccounts.push(item.account || item.userAccount);
						this.form.autoAssignUserIds.push(item.userId);
						this.form.autoAssignUserNicknames.push(item.nickname|| item.userNickname);
					}
					this.form.autoAsign =  data.lists.length > 0 ? `您已选择${data.lists.length}个坐席` :'0';
				}
			},
			getTaskNum(){
				this.$api.getTaskBreathTaskNumber({
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					batchNum:this.form.originalBatchNum,
				}).then(res => {
					if(res.errcode != 0) return;
					this.notCreatedCount = res.data.notCreatedCount || 0;;
				})
			},
			onShow(data,type){
				this.dialog_visible = true;
				this.isSubmitTask = false;
				if(type == 'task'){
					this.is_show_step = true;
					this.active = 2;
					this.taskFinishTime = '';
					this.isHadTaskFinishTime = false;
					this.form.originalBatchNum = data.originalBatchNum;
					this.form.subjectId = data.subjectId;
					this.getTaskNum();
					return ;
				}
				this.active = 1;
				if(type == 'add'){
					this.is_show_step = true;
					this.resetForms(data);
					return;
				}
				if(type == 'edit'){
					this.is_show_step = false;
					this.resetForms(data);
					this.$nextTick(() => {
						this.getInfos(data)
					})
				}
				
			},
			resetForms(data){
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					Object.keys(this.form).map(item => {
						this.form[item] = ''
					})
					this.form.autoAssignType = 'auto';
					this.form.subjectStatus = '2';
					this.form.autoAssignUserAccounts = [];
					this.form.autoAssignUserIds = [];
					this.form.autoAssignUserNicknames = [];
					this.obAutoAssignUserList = [];
					this.form.campaignName = data.campaignName;
					this.form.campaignId = data.campaignId;
					this.form.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
					
					
				})
			},
			getInfos(data){
				this.$api.getBreathThemeListInfo({
					subjectId:data.subjectId,
					brandIdentify:data.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					Object.keys(this.form).map(item => {
						this.form[item] = res.data.obSubject[item] || '';
					})
					this.obAutoAssignUserList = res.data.autoAssignUserIds ? res.data.obAutoAssignUserList : [];
					let userIds = res.data.autoAssignUserIds ? res.data.autoAssignUserIds.split(',') : [];
					this.form.autoAsign = userIds.length > 0 ? `您已选择${userIds.length}个坐席` :'0';
					this.form.subjectId = res.data.obSubject.subjectId;
					this.form.autoAssignUserAccounts = res.data.autoAssignUserAccounts ? res.data.autoAssignUserAccounts.split(','):[];
					this.form.autoAssignUserIds = res.data.autoAssignUserIds ? res.data.autoAssignUserIds.split(','):[];
					this.form.autoAssignUserNicknames = res.data.autoAssignUserNicknames ? res.data.autoAssignUserNicknames.split(','):[];
					this.getQuestionOptions();
					this.getDataBaseOptions();
				})
			},
			// 外呼问卷数据
			getQuestionOptions(val){
				this.$api.apiGetSurveyPaperList({
					pageSize:50,
					pageNumber:1,
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					paperName:val || '',
					subBrandIdentify: this.form.childBrandIdentify,//this.form.childBrandIdentify
					channelIdentify: '',
					paperId: '',
					paperStatus:'0' 
				}).then(res => {
					if(res.errcode != 0) return;
					this.questionEventOptions = res.data;
					
				})
			},
			getDataBaseOptions(val){
				this.$api.getBreathdataBaseFileList({
					pageSize:50,
					pageNumber:1,
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					name:val || ''
				}).then(res => {
					if(res.errcode != 0) return;
					this.databaseOptions = res.data;
				})
			}
		},
		mounted(){
			this.childBrandOptions = this.subBrandList;	
		}
	}
</script>

<style lang="scss" scoped>
	.breathe-create-theme {
		section {
			padding: 0 20px;
		}
		h1 {
			font-size: 14px;
			cursor: pointer;
		}
		.footer {
			display: flex;
			justify-content: flex-end;
			padding-right: 20px;
			margin: 20px 0;
		}
		.el-row-flex {
			::v-deep {
				.el-form-item__content {
					display: flex;
				}
			}
		}
		.step-two {
			font-size: 14px;
			p {
				margin-bottom: 20px;
				&.desc {
					display: flex;
					flex-direction: column;
					color: #5e6d82;
					span {
						line-height: 25px;
						font-size: 12px;
					}
				}
			}
		}
		::v-deep {
			.el-step__head.is-wait {
				color: #303133;
				border-color: #303133;
			}
			.el-step__title.is-wait {
				color: #303133;
				font-weight: bold;
			}
		}
	}
</style>
